module.exports = __webpack_public_path__ + "img/dog.3e6563ac.jpg";